import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-16 md:py-24 px-4 bg-orange-100/30" data-id="element-88">
      <div className="max-w-4xl mx-auto" data-id="element-89">
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl border-4 border-yellow-400 overflow-hidden" data-id="element-90">
          <div className="bg-yellow-400 py-6 px-4 text-center" data-id="element-91">
            <h2 className="text-3xl md:text-4xl font-black text-black uppercase" data-id="element-92">
              Kit Completo Psicopedagogía Lista (ARG)
            </h2>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-93">
            <div className="mb-8" data-id="element-94">
              <p className="text-2xl md:text-3xl text-gray-500 font-bold mb-2" data-id="element-95">
                Antes:{' '}
                <span className="line-through decoration-red-500 decoration-4" data-id="element-96">
                  $49.990
                </span>
              </p>
              <p className="text-6xl md:text-8xl font-black text-green-600 drop-shadow-sm" data-id="element-97">
                $19.990 <span className="text-3xl md:text-4xl" data-id="element-98">ARS</span>
              </p>
            </div>

            <div className="bg-gray-100 rounded-xl p-6 mb-10 inline-block text-left" data-id="element-99">
              <ul className="space-y-3 text-lg md:text-xl font-bold text-gray-800" data-id="element-100">
                <li className="flex items-center gap-3" data-id="element-101">
                  <span className="text-green-500" data-id="element-102">✓</span> 6 tomos + 3 bonos
                </li>
                <li className="flex items-center gap-3" data-id="element-103">
                  <span className="text-green-500" data-id="element-104">✓</span> Entrega por Drive
                  (PDF + Word)
                </li>
                <li className="flex items-center gap-3" data-id="element-105">
                  <span className="text-green-500" data-id="element-106">✓</span> Garantía 7 días
                </li>
              </ul>
            </div>

            <div className="mb-4" data-id="element-107">
              <p className="text-2xl md:text-3xl font-black text-red-600 mb-6 animate-pulse" data-id="element-108">
                🔥 ¡Solo por hoy a este precio!
              </p>
              <CTAButton text="COMPRAR AHORA" showArrow={true} className="w-full md:w-auto md:px-16 md:py-6 md:text-3xl" data-id="element-109" />
            </div>
            <p className="text-sm text-gray-500 mb-8 font-medium" data-id="element-110">
              ⏰ Oferta válida por tiempo limitado
            </p>

            <div className="border-t border-gray-200 pt-8" data-id="element-111">
              <div className="flex items-center justify-center gap-3 text-sm md:text-base bg-green-50 text-green-800 py-4 px-6 rounded-xl inline-flex mx-auto" data-id="element-112">
                <ShieldCheck className="w-7 h-7 text-green-600 flex-shrink-0" data-id="element-113" />
                <span className="font-bold text-left" data-id="element-114">
                  Pago seguro con Mercado Pago. Luego del pago enviamos el
                  acceso por Drive.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}